import { onServerPrefetch, useSSRContext } from 'vue';

interface UseDirectoryServerPrefetchParams {
  fetchData: () => Promise<void>;
  buildTrackingPayload?: () => Record<string, unknown> | undefined;
}

/**
 * Shared SSR prefetch for new directory SRPs.
 * Propagates thrown errors onto `ssrContext.error` so Lambda can return real 404/301 responses.
 */
export function useDirectoryServerPrefetch({
  fetchData,
  buildTrackingPayload,
}: UseDirectoryServerPrefetchParams): void {
  onServerPrefetch(async () => {
    const ssrContext = useSSRContext();

    try {
      await fetchData();
    } catch (error) {
      if (ssrContext) {
        ssrContext.error = error;
      }
      return;
    }

    if (ssrContext && buildTrackingPayload) {
      const payload = buildTrackingPayload();
      if (payload) {
        ssrContext.pageTrackingContext = JSON.stringify(payload);
      }
    }
  });
}
